import ArticleViewer from './ArticleViewer'
export default ArticleViewer
